var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('file-summaries',{attrs:{"response":_vm.files_response,"hasMore":_vm.has_more},on:{"loadMore":_vm.onLoadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }